module.exports = __webpack_public_path__ + "static/img/gzwyh.aedf1e0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/views/mobile/MemberCenter/assets/images/gzwyh.jpg
// module id = v864
// module chunks = 11